import {GameContext, Guess} from '../content/GameContext';

export class ResultsSharer<T> {
    constructor(private context: GameContext<T>) {

    }

    copyToClipboard(results: Guess<T>[]) {
        const result = this.context.getResultMessage(results);
        navigator.clipboard.writeText(result).then(() => {
            //TODO add callback
            console.log(`copied to clipboard\n${result}`);
        });
    }

    //TODO implement sharing via other websites
}
